<script setup lang="ts">
import { ratingImage } from '@/config/google-review'

const { t } = useI18n()

</script>

<script lang="ts">
export default {
  name: 'WhoWeAreHappyClients'
}
</script>

<template>
  <div class="px-24 lg:px-90 py-56 lg:py-64">
    <div class="max-w-screen-lg mx-auto">
      <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-24 text-center">
        <h2 class="lg:display-4 display-6 text-pine-600">
          #clientesfelices
        </h2>

        <div
          data-lh-id="who-we-are-happy-clients-google-reviews"
          class="flex flex-col items-center gap-4 justify-center">
          <div class="grid grid-flow-col pointer-events-none gap-4 w-[250px] self-center">
            <img
              v-for="(img, index) in ratingImage"
              :key="index"
              :src="img.src"
              :alt="img.alt"
              loading="lazy"
              :width="img.width"
              :height="img.height"
              :class="img.class"
              class="pointer-events-none">

            <p class="col-start-2 pointer-even body-1-m lg:hl-3-m ts-none mt-6 lg:mt-0">
              {{ t('qualification') }}
            </p>
          </div>

          <p class="pt-4 pointer-events-none body-1-m lg:hl-3-m text-center lg:w-full lg:text-left">
            {{ t('total_reviews') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json"></i18n>
